'use client'

import {ReactNode, useEffect} from 'react'
import {createPortal} from 'react-dom'
import classnames from 'classnames'

import Button from '../Button'
import Icon from '../Icon'
import {Text} from '../Text'

import sizes from './sizes.module.css'
import styles from './styles.module.css'

export type TModalProps = {
  children?: ReactNode
  isModalOpen: boolean
  type: 'video' | 'popupTop' | 'popupBottom' | 'alert'
  onClose: () => void
  title?: string
  modalClassName?: string
  closeButton?: boolean
  inModal?: boolean
  id?: string
}

export function Modal({
  children,
  isModalOpen,
  type,
  onClose,
  title,
  modalClassName,
  closeButton = true,
  inModal,
  id,
}: TModalProps) {
  useEffect(() => {
    const handleEsc = (event: {key: string}) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEsc)

    return () => {
      document.removeEventListener('keydown', handleEsc)
    }
  }, [])

  return (
    <>
      {isModalOpen &&
        createPortal(
          <>
            <div
              className={classnames(styles.background, {[styles.open]: isModalOpen, [styles.transparentBg]: inModal})}
              onClick={onClose}
            />
            <div
              id={id}
              className={classnames(styles.rootWrapper, {[styles.open]: isModalOpen}, styles[type], sizes.root)}
            >
              <div className={classnames(styles.root, modalClassName)} role="dialog" aria-modal="true">
                {closeButton && (
                  <Button variant="hollow" className={styles.closeButton} onClick={onClose}>
                    <Icon name="close" color={type === 'video' ? 'white' : 'black'} />
                  </Button>
                )}
                {title && (
                  <Text
                    className={styles.title}
                    tag={type === 'alert' ? 'p' : 'h2'}
                    kind={type === 'alert' ? 'label' : 'header'}
                  >
                    {title}
                  </Text>
                )}
                <div className={styles.children}>{children}</div>
              </div>
            </div>
          </>,
          document.body,
        )}
    </>
  )
}
